
import { CheckCircle, GitBranch, Users, Zap } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const userBenefits = [
  "No coding required — design Bayesian analyses with easy-to-use visual workflows",
  "Accelerate your analysis with pre-built nodes for data preparation, modelling, and visualisation",
  "Easily reuse, adapt, and share workflows across teams for faster collaboration",
  "See real-time Bayesian insights with visualisations that update automatically as your data evolves"
];

const About = () => {
  return (
    <section id="about" className="section-padding bg-background">
      <div className="container-narrow">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <AnimatedSection animation="fade-in-left">
            <div className="inline-block px-3 py-1 mb-6 rounded-full bg-primary/10 text-primary text-xs font-medium tracking-wider">
              ABOUT US
            </div>
            <h2 className="text-3xl md:text-4xl font-display font-bold tracking-tight mb-6">
              Your Bayesian Toolbox — No Code Needed
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              We make Bayesian analysis accessible to everyone — empowering data teams, analysts, and decision-makers to explore data, model uncertainty, and uncover valuable insights with intuitive visual workflows.
            </p>
            
            <h3 className="text-xl font-semibold mb-4">Key Benefits</h3>
            <div className="space-y-4">
              {userBenefits.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-primary flex-shrink-0" />
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </AnimatedSection>
          
          <AnimatedSection animation="fade-in-right" delay={200}>
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-border/50">
              <h3 className="text-2xl font-display font-semibold mb-6">
                Who We're Building For
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-primary/10">
                    <Users className="h-8 w-8 text-primary" />
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-1">Data Teams</h4>
                    <p className="text-muted-foreground">Design, customise, and share Bayesian workflows that support advanced modelling, parameter tuning, and collaborative analysis across teams</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-primary/10">
                    <GitBranch className="h-8 w-8 text-primary" />
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-1">Business Analysts</h4>
                    <p className="text-muted-foreground">Incorporate Bayesian analysis into your everyday workflows — using intuitive, no-code visual tools to explore data and uncover insights</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-primary/10">
                    <Zap className="h-8 w-8 text-primary" />
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-1">Decision Makers</h4>
                    <p className="text-muted-foreground">Get the insights you need, when you need them — with automated workflows that keep up as your data changes</p>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default About;
